module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("drBRk"))).then(() => parcelRequire('hEqeo'));